import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './FiltersDrawer.styles';
import { BooleanCollection } from '@/components/Filters/FiltersDrawer.types';
import { Property } from '@/api/types/categories.types';

const options = [
  { label: 'common.no_matter', value: undefined },
  { label: 'common.yes', value: true },
  { label: 'common.no', value: false },
];

type Props = {
  property: Property;
  collection: BooleanCollection;
  setCollection: React.Dispatch<React.SetStateAction<BooleanCollection>>;
};

export const BooleanOptions = ({
  property,
  collection,
  setCollection,
}: Props) => {
  const { t } = useTranslation();

  const handleChange = (value: boolean | undefined) => {
    setCollection(prev => ({ ...prev, [property.legacyResourceId]: value }));
  };

  return (
    <S.FieldWithTitleWrapper
      data-testid={`boolean-property-${property.legacyResourceId}`}
    >
      <S.FieldTitle>{property.name}</S.FieldTitle>
      <S.ChipsContainer>
        {options.map(option => {
          const isSelected =
            collection[property.legacyResourceId] === option.value;
          return (
            <S.Chip
              key={option.label}
              appearance={isSelected ? 'primary' : 'gray'}
              isRounded
              onClick={() => handleChange(option.value)}
            >
              {t(option.label)}
            </S.Chip>
          );
        })}
      </S.ChipsContainer>
    </S.FieldWithTitleWrapper>
  );
};
